// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__rUOBa","disabled":"Switch_disabled__yJFoX","on":"Switch_on__O6nV9"};